<template>
  <div>
    <Heading v-bind="headingProps" header headerColor="gray scale200" class="pb-0 text-h3" v-if="!accessSupportPanel">
      <template #subtitle>
        <HTMLRender class="text-h4 mt-6" locale="plans.subtitle" :values="subtitleValues"/>
        <p class="mt-1 text-paragraph-2" v-text="t$.description"/>
      </template>
      <template #action>
        <Button :label="t$.headerAction" outlined color="primary" @click="newPlan" medium />
      </template>
    </Heading>
    <AlertNewPanel/>
    <LoadingArea style="position: relative; z-index: 2" :display-content="!loading">
      <template #loading>
        <Row>
          <Col v-for="i in 8" :key="i" cols="12">
            <SkeletonLoader type="list-item-three-line" elevation="1"/>
          </Col>
        </Row>
      </template>
      <template v-if="hasPlans && !accessSupportPanel">
        <Row tag="ul">
          <Col cols="12" tag="li" v-for="(plan,index) in data" :key="plan.id" class="translate-top-animation"
               :style="`animation-delay: ${20 * index}ms`">
            <PlanCard :plan="plan"/>
          </Col>
        </Row>
      </template>
      <template v-if="!hasPlans && !accessSupportPanel">
        <PageResult class="mt-16" :error="error" :text-results="t$.result" :actionRoute="createLink" external-action/>
      </template>
      <template v-if="accessSupportPanel">
        <PageSupportPanel class="mt-16" :text-results="t$.result" :currentUser="currentUser" />
      </template>
    </LoadingArea>
  </div>
</template>

<script>
import {
  Col,
  Heading,
  HTMLRender,
  LoadingArea,
  Row,
  SkeletonLoader,
  useAPI,
  useLocale,
  Button
} from '@locaweb/design-system-vue'
import { findAll } from '@/views/plan/api/plan.api'
import { computed, onBeforeMount } from 'vue'
import PageResult from '@/components/PageResult'
import PageSupportPanel from '@/components/PageSupportPanel'
import PlanCard from '@/views/plan/components/PlanCard'
import { authStore } from '@/store/auth'
import AlertNewPanel from '@/components/AlertNewPanel'

export default {
  name: 'PlanList',
  components: {
    AlertNewPanel,
    PlanCard,
    PageResult,
    PageSupportPanel,
    LoadingArea,
    SkeletonLoader,
    Row,
    Col,
    Heading,
    HTMLRender,
    Button
  },
  methods: {
    newPlan () {
      window.open('https://www.locaweb.com.br/hospedagem-wordpress/', '_blank')
    }
  },
  setup () {
    const {
      data,
      execute,
      loading,
      error
    } = useAPI({ request: findAll })
    const currentUser = authStore().user
    const hasPlans = computed(_ => data.value && !data.value.isEmpty())
    const t$ = useLocale('plans')
    const subtitleValues = { name: authStore().user.name }
    const headingProps = computed(_ => ({
      title: t$.title,
      icon: '$brand-wordpress-filled',
      divider: false,
      header: !error.value && hasPlans.value,
      large: true,
      outlined: true,
      actionColor: 'primary'
    }))

    const accessSupportPanel = currentUser.type === 'Employee'

    onBeforeMount(_ => execute())

    const createLink = process.env.VUE_APP_FICHA_URL

    return {
      data,
      loading,
      error,
      hasPlans,
      t$,
      createLink,
      subtitleValues,
      headingProps,
      currentUser,
      accessSupportPanel
    }
  }
}
</script>

<style lang="scss">
.container .ds-breadcrumbs{
    display: none
  }
  .main_content .ds-breadcrumbs{
    display: block;
  }
ul {
  list-style: none;
  padding-left: 0 !important;
}

.translate-top-animation {
  opacity: 0;
  animation: translate-top 250ms ease-in-out 0s 1 normal forwards;
}

@keyframes translate-top {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: translateY(45px);
  }
  100% {
    animation-timing-function: ease-out;
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
